<template>
  <div>
    <dx-data-grid
      ref="dataGrid"
      :columns="columns"
      :data-source="store"
      :remote-operations="remoteOperations"
      :allow-column-resizing="true"
      :show-borders="true"
      :show-row-lines="false"
      :show-column-lines="true"
      :row-alternation-enabled="true"
      @init-new-row="onInitNewRow"
      @row-inserted="reloadResources"
      @row-updated="reloadResources"
    >
      <dx-editing
        :allow-adding="true"
        :allow-updating="true"
        :allow-deleting="true"
        mode="batch"
      />

      <dx-sorting mode="multiple"/>

      <dx-filter-row :visible="true"/>
      <dx-filter-panel :visible="true"/>

      <dx-paging :page-size="20"/>
      <dx-pager
        :allowed-page-sizes="[15, 20, 50]"
        :visible="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid } from 'devextreme-vue';
import {
  DxEditing,
  DxFilterPanel,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxSorting,
} from 'devextreme-vue/data-grid';
import createBackendStore from '@/lib/create-backend-store';
import { buildColumns } from '@/lib/data-grid-columns';

export default {
  name: 'LocaleGrid',
  components: {
    DxDataGrid,
    DxEditing,
    DxFilterRow,
    DxFilterPanel,
    DxPager,
    DxPaging,
    DxSorting,
  },
  props: {
    namespace: { type: String, default: 'default' },
  },
  data() {
    return {
      columns: [],
      store: null,
      remoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
    };
  },
  computed: {
    dataGrid() {
      return this.$refs.dataGrid.instance;
    },
  },
  watch: {
    namespace(value) {
      this.dataGrid.columnOption('namespace', 'filterValue', value);
    },
  },
  methods: {
    buildColumns,
    configureColumns() {
      return [
        ...this.buildColumns('locale', [
          {
            property: 'id',
            visible: false,
          },
          {
            property: 'namespace',
            visible: false,
            filterOperations: ['='],
          },
          {
            property: 'key',
            sortOrder: 'asc',
            width: '33%',
          },
          {
            property: 'language',
            sortOrder: 'asc',
            width: '10%',
          },
          {
            property: 'translation',
          },
        ]),
        {
          type: 'buttons',
          width: 40,
          allowResizing: false,
        },
      ];
    },
    configureStore(columns) {
      return createBackendStore('/locales', {
        fields: columns.map(c => c.dataField).filter(f => f),
      });
    },
    refresh() {
      this.dataGrid.refresh();
    },
    async reloadResources() {
      await this.$i18n.i18next.reloadResources();
    },
    onInitNewRow(event) {
      // eslint-disable-next-line no-param-reassign
      event.data.namespace = this.namespace;
    },
  },
  created() {
    this.columns = this.configureColumns();
    this.store = this.configureStore(this.columns);
  },
  mounted() {
    this.dataGrid.columnOption('namespace', 'filterValue', this.namespace);
  },
};
</script>

<style scoped>

</style>
